import { isEmpty } from 'lodash';
import * as queryString from 'query-string';

import { CoordinateModel } from '../models/coordinate.model';
import { FilterItemModel } from '../models/filter.model';
import { SearchParamsModel } from '../models/search.model';
import { DataSchemeFilter } from '../store/location';

//TODO need update for nesting items
export const updateQueryString = (search: string, values: Record<string, string | string[] | number | undefined>) => {
    const searchParams: queryString.ParsedQuery = queryString.parse(search, { arrayFormat: 'comma' });
    let out = {};

    for (const [key, value] of Object.entries(values)) {
        if (value !== null && value !== undefined) {
            out = { ...out, [key]: Array.isArray(value) ? value : [value] };
        } else {
            if (!['basket', 'basketreference'].includes(key)) {
                delete searchParams[key];
            }
        }
    }

    return queryString.stringify({ ...searchParams, ...out }, { arrayFormat: 'comma' });
};

export const urlToFilters = (
    search: string,
    fromState: { collection: string[]; coordinate: CoordinateModel; filter: DataSchemeFilter }
) => {
    const searchParams: queryString.ParsedQuery = queryString.parse(search, { arrayFormat: 'comma' });
    const { filter, coordinate, collection } = fromState;
    const filterState: DataSchemeFilter = !isEmpty(filter)
        ? Object.keys(filter).reduce((acc: DataSchemeFilter, key) => {
              const searchByKey = searchParams[key] as keyof SearchParamsModel;
              const keyFilter = key as keyof DataSchemeFilter;
              if (!['bookingyear', 'basket', 'basketreference'].includes(keyFilter)) {
                  if (acc[keyFilter]) {
                      if (searchByKey) {
                          (acc[keyFilter] as FilterItemModel[]) = updateFilterBySearch(
                              searchByKey,
                              filter[keyFilter] as unknown as FilterItemModel[]
                          );
                      } else {
                          (acc[keyFilter] as FilterItemModel[]) = (filter[keyFilter] as unknown as FilterItemModel[]).map(
                              item => ({
                                  ...item,
                                  checked: false,
                              })
                          );
                      }
                  }
              }
              return acc;
          }, filter)
        : filter;

    for (const filterExceptionKey of Object.keys(searchParams)) {
        if (filterExceptionKey === 'basket') {
            const keyFilter = filterExceptionKey as keyof DataSchemeFilter;
            (filterState[keyFilter] as number) = Number(searchParams[filterExceptionKey]) as number;
        }
        if (filterExceptionKey === 'basketreference') {
            const keyFilter = filterExceptionKey as keyof DataSchemeFilter;
            (filterState[keyFilter] as string) = String(searchParams[filterExceptionKey]) as string;
        }
    }

    const coordinateState = {
        latitude: searchParams.latitude ?? coordinate.latitude,
        longitude: searchParams.longitude ?? coordinate.longitude,
        mode: searchParams.mode ?? coordinate.mode,
        name: searchParams.name ?? coordinate.name,
        radius: searchParams.radius ?? coordinate.radius,
        city: searchParams.city ?? coordinate.city,
        individualproduct: searchParams.individualproduct ?? coordinate.individualproduct,
    };

    const collectionState = searchParams.collection ?? collection;

    return {
        filter: filterState,
        coordinate: coordinateState as CoordinateModel,
        collection: Array.isArray(collectionState) ? collectionState : [collectionState],
    };
};

export const updateFilterBySearch = (searchParams: keyof SearchParamsModel, filter: FilterItemModel[]) => {
    const params: string[] = Array.isArray(searchParams) ? searchParams : searchParams.split(',');

    return filter.map(item => {
        const isChecked = params.indexOf(String(item.code)) > -1;
        if (item.subnodes) {
            return {
                ...item,
                checked: isChecked,
                subnodes: item.subnodes.map(sn => {
                    const result = { ...sn, checked: params.indexOf(String(sn.code)) > -1 };
                    if (sn.subnodes) {
                        result.subnodes = sn.subnodes.map(s => ({
                            ...s,
                            checked: params.indexOf(String(s.code)) > -1,
                        }));
                    }
                    return result;
                }),
            };
        } else {
            return { ...item, checked: isChecked };
        }
    });
};
